<script>
  import {Line} from 'vue-chartjs' // We specify what type of chart we want from vue-chartjs and the mixins module
  export default Line.extend({ // We are extending the base chart class as mentioned above
    data () {
      return {}
    },
    created: function () {
      window.Chart.defaults.global.defaultFontColor = '#aaa'
    },
    methods: {
      render: function (chartData, options) {
        this.renderChart(chartData, options)
      }
    }
  })
</script>



// WEBPACK FOOTER //
// LineChart.vue?204b55a2